/*
Item: Upload components
Name: Upload
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const SEVERITY_MAP = {
  info: 'p-message-info',
  warn: 'p-message-warn',
  success: 'p-message-success',
  error: 'p-message-error',
};

const SEVERITY_ICONS = {
  info: 'pi-info-circle',
  warn: 'pi-exclamation-triangle',
  success: 'pi-check',
  error: 'pi-times',
};

// small Massage Box displayed on upload of files in the parent component
export default class UploadMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      closeMessage, visible, severity, infoMessage,
    } = this.props;
    return (
      <div style={visible ? {} : { display: 'none' }} className={`p-col-12 p-md-12 p-message p-component p-messages-enter-done ${SEVERITY_MAP[severity]}`}>
        <div aria-live="polite" className="p-messages-wrapper">
          <button type="button" className="p-messages-close p-link upload-message-close" onClick={() => closeMessage()}>
            <i className="p-messages-close-icon pi pi-times" />
          </button>
          <span className={`p-message-icon pi pi-fw ${SEVERITY_ICONS[severity]}`} />
          <span className="p-message-text">{infoMessage}</span>
        </div>
      </div>
    );
  }
}

UploadMessage.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeMessage: PropTypes.func.isRequired,
  severity: PropTypes.string.isRequired,
  infoMessage: PropTypes.string.isRequired,
};
